import { render, staticRenderFns } from "./immersion01.vue?vue&type=template&id=7b193c6a&scoped=true&"
import script from "./immersion01.vue?vue&type=script&lang=js&"
export * from "./immersion01.vue?vue&type=script&lang=js&"
import style0 from "./immersion01.vue?vue&type=style&index=0&id=7b193c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b193c6a",
  null
  
)

export default component.exports